import React from 'react'

const home = (props) => <h1>Não encontrada</h1>

export default home